import { useEffect, useState } from 'react';
import { Environment } from '@/config/environment';

type Props = {
  locale?: string;
};

const UcBlockScript = ({ locale }: Props) => {
  const [isUcLoaded, setIsUcLoaded] = useState(false);
  const { NEXT_PUBLIC_SDP_LOCALES } = Environment.getBuildtimeEnvVars() as {
    NEXT_PUBLIC_SDP_LOCALES: string[];
  };

  useEffect(() => {
    setTimeout(() => {
      if (window.uc && window.uc.isCMPLoaded) {
        setIsUcLoaded(true);
      }
    }, 1000); // Delay to ensure UC is loaded
  }, []);

  useEffect(() => {
    if (isUcLoaded) {
      window.uc.blockOnly(['BJz7qNsdj-7']);
    }
  }, [isUcLoaded]);

  // Check if the locale is supported and if the Usercentrics SDP script should be loaded
  const isLocaleSupported = locale ? NEXT_PUBLIC_SDP_LOCALES?.includes(locale) : false;

  // Use the normal script tag to load the Usercentrics block script, because it needs to be loaded synchronously
  return (
    isLocaleSupported && (
      // eslint-disable-next-line @next/next/no-sync-scripts
      <script src="https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js" />
    )
  );
};

export default UcBlockScript;
